import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import { TaskBasicInfo } from '../tasks/task/models/task.basicinfo.model';
import { FeatureFlagService } from '@headpower/featureflags';

/**
 * This is meant to be a supporting service for AppComponent to not cause
 * circular dependencies with other services
 */
@Injectable()
export class AppComponentService {

    private ff_IwmPOC: boolean = false; // Feature flag for IWM POC

    private iwmBackendUri: string;

    /**
     * @constructor
     */
    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private featureFlagService: FeatureFlagService
    ) {
        this.featureFlagService.isFeatureAvailable('IWM.ListTaskPOC').subscribe((isAvailable) => {
            this.ff_IwmPOC = isAvailable;
        });
        this.iwmBackendUri = (this.ff_IwmPOC ? this.config.backendIwmPOCUri : this.config.backendIwmUri);
    }

    /**
     * Returns true/false if a task exists
     * @param taskId TaskId of a task or worksite
     * @returns Boolean
     */
    public doesTaskExist(taskId: number): Observable<TaskBasicInfo> {
        return this.http.get<TaskBasicInfo>(`${this.iwmBackendUri}Api/Tasks?$filter=TaskId eq ${taskId}`);
    }

    /**
     * Returns true/false if a wom task exists
     * @param taskId TaskId of a wom task
     * @returns Boolean
     */
    public doesWomTaskExist(taskId: number): Observable<any> {
        return this.http.get(`${this.iwmBackendUri}Api/ListTasks?$filter=TaskId eq ${taskId} and System eq 'Wom'`);
    }

    /**
     * function to get authentication ticket for accessing old dipo records
     * This will be later changed to dipo library if the thing is used in web app
     */
    getTicket() {
        return this.http.get(this.config.backendPortalUri + 'WebAPI/api/Ticket/GetAuthenticationTicket');
    }
}